(function () {
  function normalizeString(str) {
    return str
      .normalize('NFD')
      .replace(/\p{Diacritic}/gu, '')
      .toLowerCase();
  }

  document.querySelectorAll('[data-bhcr-country-selector]').forEach(function (selector) {
    var button = selector.querySelector('.disclosure__button');
    var panel = selector.querySelector('.bhcr-country-selector__panel');
    var search = selector.querySelector('[data-bhcr-country-search]');
    var resetButton = selector.querySelector('[data-bhcr-country-search-reset]');
    var liveRegion = selector.querySelector('[aria-live="polite"]');

    if (!button || !panel) return;

    function syncPanelHeight() {
      var rect = button.getBoundingClientRect();
      var available = rect.top - 16;
      var capped = Math.min(352, window.innerHeight * 0.5, Math.max(160, available));
      panel.style.maxHeight = capped + 'px';
    }

    function hidePanel() {
      button.setAttribute('aria-expanded', 'false');
      panel.setAttribute('hidden', '');
      panel.style.maxHeight = '';
      if (search) {
        search.value = '';
        filterCountries();
      }
    }

    function openPanel() {
      syncPanelHeight();
      button.setAttribute('aria-expanded', 'true');
      panel.removeAttribute('hidden');
      if (search) search.focus();
    }

    function filterCountries() {
      if (!search) return;

      var searchValue = normalizeString(search.value.trim());
      var popularCountries = selector.querySelector('.bhcr-country-selector__popular');
      var items = selector.querySelectorAll('.bhcr-country-selector__countries .disclosure__item');
      var visibleCountries = 0;

      if (resetButton) resetButton.classList.toggle('hidden', !searchValue);
      if (popularCountries) popularCountries.classList.toggle('hidden', !!searchValue);

      items.forEach(function (item) {
        var link = item.querySelector('a.disclosure__link');
        if (!link) return;

        var countryName = link.querySelector('.country');
        var currency = link.querySelector('.localization-form__currency');
        var haystack = normalizeString(
          (countryName ? countryName.textContent : '') + ' ' + (currency ? currency.textContent : '')
        );
        var matches = !searchValue || haystack.indexOf(searchValue) > -1;

        item.classList.toggle('hidden', !matches);
        if (matches) visibleCountries++;
      });

      if (liveRegion && window.accessibilityStrings) {
        liveRegion.textContent = window.accessibilityStrings.countrySelectorSearchCount.replace(
          '[count]',
          visibleCountries
        );
      }

      var list = selector.querySelector('.bhcr-country-selector__list');
      if (list) list.scrollTop = 0;
    }

    button.addEventListener('click', function () {
      if (button.getAttribute('aria-expanded') === 'true') {
        hidePanel();
      } else {
        openPanel();
      }
    });

    selector.addEventListener('focusout', function (event) {
      if (selector.contains(event.relatedTarget)) return;
      hidePanel();
    });

    selector.addEventListener('keydown', function (event) {
      if (event.code.toUpperCase() === 'ESCAPE') {
        hidePanel();
        button.focus();
      }
    });

    if (search) {
      search.addEventListener('input', filterCountries);
      search.addEventListener('keydown', function (event) {
        if (event.code.toUpperCase() === 'ENTER') event.preventDefault();
      });
    }

    if (resetButton && search) {
      resetButton.addEventListener('click', function (event) {
        event.preventDefault();
        search.value = '';
        filterCountries();
        search.focus();
      });
    }

    window.addEventListener('resize', function () {
      if (button.getAttribute('aria-expanded') === 'true') syncPanelHeight();
    });
  });
})();
